import React, { Component } from 'react';
import { Table, Button,Alert,Tag,Input,List, Card,Avatar, Icon, Rate,message  } from 'antd';
import { Link } from "react-router-dom";
import Moment from 'react-moment';
const { Search } = Input;
const { Meta } = Card;

const queryString = require('query-string');

class GenTable extends Component {
    constructor(props) {
        super(props);
        this.state = {  filteredInfo: null,
          searchvalue:'',
            sortedInfo: null,
            filteredBranch:  [],
            columns : null,
            columnsData:null,
            dynamicData:null,
            tableData:null,
            filteredInfo:{
              branch:null,
              campus:null,
              section:null
            },
            filteredCampus:  [],
            filteredSection : [],
            selectedRowKeys: [],
            category:"Student" }
    }

    componentDidMount() {
        var parsed = queryString.parse(this.props.props.location.search);
        this.setState({tableData:this.props.data})

        if(parsed && parsed.Category&& parsed.Category.length>0 && (parsed.Category=="Student" || parsed.Category=="Faculty")){
          this.setState({ category:parsed.Category});
        }
        else{
          this.setState({ category:"Student"});
        }

        if(!parsed.Branch || parsed.Branch=='null'){
          parsed.Branch=null ||this.props.branch
        }

        if(parsed.Branch ){
          parsed.Branch=[parsed.Branch]
        }

        if(!parsed.Campus || parsed.Campus=='null'){
          parsed.Campus=null || this.props.campus
        }

        if(parsed.Campus){
          parsed.Campus=[parsed.Campus]
        }

        if(!parsed.Section || parsed.Section=='null'){
          parsed.Section=null || this.props.section
        }

        if(parsed.Section){
          parsed.Section=[parsed.Section]
        }

        if(parsed.Branch || parsed.Campus || parsed.Section ){
          this.setState({
                filteredBranch: [parsed.Branch],
                filteredCampus: [parsed.Campus],
                filteredSection: [parsed.Section],
                filteredInfo:  {branch : parsed.Branch, campus:parsed.Campus, section:parsed.Section}
          })
        }
        
      }

    handleChange = (pagination, filters, sorter) => {
        this.setState({
          filteredBranch: filters.branch || [],
          filteredCampus: filters.campus || [],
          filteredSection : filters.section || [],
          filteredInfo: filters,
          sortedInfo: sorter,
        });
      };
    
      clearAll = () => {
        this.setState({
          filteredBranch:  [],
          filteredCampus:  [],
          filteredSection : [],
          filteredInfo: null,
          sortedInfo: null,
        });
      };
    
      setAgeSort = () => {
        this.setState({
          sortedInfo: {
            order: 'descend',
            columnKey: 'age',
          },
        });
      };

      onSelectChange = (selectedRowKeys, selectedRows) => {
        const selected = Array.prototype.map
          .call(selectedRows, function(item) {
            return item.email;
          })
          .join(",");
        this.setState({ selected });
        this.setState({ selectedRowKeys });
      };
    
      sendMail = () => {
        
        window.open(
          "mailto:" + this.state.selected,
          "name",
          "height=900,width=900"
        );
      };

      searchTable = (value,dataTable) => {


        const newData= dataTable.filter(data=> Object.keys(data).filter(key => (data[key]&& ((data[key]).toString().toUpperCase()).includes((value).toUpperCase()))).length > 0 ? true: false)
        this.setState({tableData:newData})
        
       };

    render() { 
        let { sortedInfo, filteredInfo,selectedRowKeys,filteredBranch, filteredCampus, filteredSection,columnsData,dynamicData,tableData } = this.state;
        sortedInfo = sortedInfo || {};
        filteredInfo = filteredInfo || {};
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
            onSelect: this.onSelect
          };
          const Studentcolumns = [
            {
             title: 'S.no',
             width:65,
             render: (text, row, index) => (
               <>{index+1}</>
             )
           },
           {
             title: 'Name',
             dataIndex: 'fullName',
             key: 'fullName',
             sorter: (a, b) => a.fullName && a.fullName.localeCompare(b.fullName),
             width:150,
             render: (text, row, index) => (
               <Link  to={`/home/profile/${row.UID}`}>{text}</Link>
             )
           },
           {
            title: 'Roll Number',
            dataIndex: 'rollnumber',
            key: 'rollnumber',
            width:120,
            render: (text, row, index) => (
            <><Tag color="#2db7f5">{text}</Tag></>
            )
          },
          {
            title: 'gradYear',
            dataIndex: 'gradYear',
            key: 'gradYear',
            filters: [{text: '2019',value: '2019'},{text: '2020',value: '2020'},{text: '2021',value: '2021'},{text: '2022',value: '2022'},{text: '2023',value: '2023'},{text: '2024',value: '2024'},{text: '2025',value: '2025'}],
            filteredValue: filteredInfo.gradYear || null,
            onFilter: (value, record) =>  record && record.gradYear && record.gradYear.match(new RegExp('^'+value+'$','g')),
            width: 80,
          },
           {
               title: 'Campus',
               dataIndex: 'campus',
               key: 'campus',
               width:100,
               filters: [{text: 'BVRIT',value: 'BVRIT'},{text: 'VIT',value: 'VIT'},{text: 'BVRITH',value: 'BVRITH'},{text: 'SVECW',value: 'SVECW'}],
               filteredValue: filteredInfo.campus || null,
               onFilter: (value, record) => record && record.campus && record.campus.match(new RegExp('^'+value+'$','g')),
              
             },
             {
               title: 'Branch',
               dataIndex: 'branch',
               key: 'branch',
               width:100,
               filters: [{text: 'ECE',value: 'ECE'},{text: 'CSE',value: 'CSE'},{text: 'IT',value: 'IT'},{text: 'EIE',value: 'EIE'},{text: 'EEE',value: 'EEE'},{text: 'MECH',value: 'MECH'}],
               filteredValue: filteredInfo.branch || null,
               onFilter: (value, record) => record && record.branch && record.branch.match(new RegExp('^'+value+'$','g')),
             
             },
             {
               title: 'Total',
               width:100,
               dataIndex: 'certificationArray',
               key: 'certificationArray',
               render: skillLearntAtInternship => (
              
                 <span>
                 {skillLearntAtInternship.length}
               </span>
               ),
             defaultSortOrder: 'descend',
             sorter: (a, b) => a.certificationArray && a.certificationArray.length-b.certificationArray.length,
             },
             {
               title: 'Certifications',
               dataIndex: 'certification',
               key: 'certification',
               render: skillLearntAtInternship => (
                 <List
                 pagination={{pageSize:1,size:'small',showLessItems:true}}
                 grid={{
                   gutter: 8,
                   column: 1
                 }}
                 dataSource={ Object.keys(skillLearntAtInternship).map((el, index) => {
                  return {
                    ...skillLearntAtInternship[el],
                    index
                  };
                })}
                 renderItem={item => {
                   return (
                     <List.Item key={item.certificationName}>
                       <Card bodyStyle={{padding:10}}>
                       <Meta
                 title={item.certificationName}
               />
              
               <div
                 style={{
                   marginTop: 2
                 }}
               >
                 <Icon type="book" />
                 Company : {item.certificationAuthority}{" "}
               </div>
              
               <div
                 style={{
                   marginTop: 10
                 }}
               >
                  <Icon type="retweet" />Type: {item.certificationType}
               </div>
               <div
                 style={{
                   marginTop: 10
                 }}
               >
                 {item.skillLearntAtCertification.map(i => (
                   <Tag style={{ marginBottom: 5,overflow:'hidden',width:'100%' }} key={i}>
                     {i.toUpperCase()}
                   </Tag>
                 ))}{" "}
               </div>
             </Card>
                     </List.Item> 
                   )
                 }}

                 >

                 </List>
               )
             }

         ];

         const Facultycolumns = [
          {
           title: 'S.no',
           width:65,
           render: (text, row, index) => (
             <>{index+1}</>
           )
         },
         {
           title: 'Name',
           dataIndex: 'fullName',
           key: 'fullName',
           sorter: (a, b) => a.fullName && a.fullName.localeCompare(b.fullName),
           width:150,
           render: (text, row, index) => (
             <Link  to={`/home/profile/${row.UID}`}>{text}</Link>
           )
         },
         {
             title: 'Campus',
             dataIndex: 'campus',
             key: 'campus',
             width:100,
             filters: [{text: 'BVRIT',value: 'BVRIT'},{text: 'VIT',value: 'VIT'},{text: 'BVRITH',value: 'BVRITH'},{text: 'SVECW',value: 'SVECW'}],
             filteredValue: filteredInfo.campus || null,
             onFilter: (value, record) => record && record.campus && record.campus.match(new RegExp('^'+value+'$','g')),
            
           },
           {
             title: 'Branch',
             dataIndex: 'branch',
             key: 'branch',
             width:100,
             filters: [{text: 'ECE',value: 'ECE'},{text: 'CSE',value: 'CSE'},{text: 'IT',value: 'IT'},{text: 'EIE',value: 'EIE'},{text: 'EEE',value: 'EEE'},{text: 'MECH',value: 'MECH'}],
             filteredValue: filteredInfo.branch || null,
             onFilter: (value, record) => record && record.branch && record.branch.match(new RegExp('^'+value+'$','g')),
           
           },
           {
             title: 'Total',
             width:100,
             dataIndex: 'certificationArray',
             key: 'certificationArray',
             render: skillLearntAtInternship => (
            
               <span>
               {skillLearntAtInternship.length}
             </span>
             ),
           defaultSortOrder: 'descend',
           sorter: (a, b) => a.certificationArray && a.certificationArray.length-b.certificationArray.length,
           },
           {
             title: 'Certifications',
             dataIndex: 'certification',
             key: 'certification',
             render: skillLearntAtInternship => (
               <List
               pagination={{pageSize:1,size:'small',showLessItems:true}}
               grid={{
                 gutter: 8,
                 column: 1
               }}
               dataSource={ Object.keys(skillLearntAtInternship).map((el, index) => {
                return {
                  ...skillLearntAtInternship[el],
                  index
                };
              })}
               renderItem={item => {
                 return (
                   <List.Item key={item.certificationName}>
                     <Card bodyStyle={{padding:10}}>
                     <Meta
               title={item.certificationName}
             />
            
             <div
               style={{
                 marginTop: 2
               }}
             >
               <Icon type="book" />
               Company : {item.certificationAuthority}{" "}
             </div>
            
             <div
               style={{
                 marginTop: 10
               }}
             >
                <Icon type="retweet" />Type: {item.certificationType}
             </div>
             <div
               style={{
                 marginTop: 10
               }}
             >
               {item.skillLearntAtCertification.map(i => (
                 <Tag style={{ marginBottom: 5,overflow:'hidden',width:'100%' }} key={i}>
                   {i.toUpperCase()}
                 </Tag>
               ))}{" "}
             </div>
           </Card>
                   </List.Item> 
                 )
               }}

               >

               </List>
             )
           }

       ];
          
    const hasSelected = selectedRowKeys.length > 0;
    return (
      <div>
        <div style={{ marginBottom: 16 }}>
                <Button
                  onClick={this.sendMail}
                  type="primary"
                  disabled={!hasSelected}
                >
                  Send Mail
                </Button>
                <span style={{ marginLeft: 8 }}>
                  {hasSelected
                    ? `Selected ${selectedRowKeys.length} items`
                    : ""}
                </span>
              </div>

              {filteredBranch.length > 0 ||filteredCampus.length>0 || filteredSection.length>0 ? (
                <>
                  <Alert
                    message={`Filtered by "${filteredCampus.toString()}" Campus | ${filteredBranch.toString()} Branch | ${filteredSection.toString()} Section`}
                    type="info"
                    showIcon
                  />{" "}
                  <Button
                    type="primary"
                    icon="close"
                    onClick={this.clearAll}
                    style={{ marginBottom: 25, marginTop: 10 }}
                  >
                    Clear Filters
                  </Button>{" "}
                </>
              ) : null}

{(Studentcolumns || Facultycolumns) && this.props.data && tableData ?  <Table 
       
       title={() => <><Search
         placeholder="Search in table"
         enterButton="Search"
         size="large"
         style={{width:'85%',marginRight:10}}
         allowClear 
         onSearch={value => this.searchTable(value,this.props.data)}
       /><Button style={{background:'#001529',color:'white'}} onClick={()=>message.info('Feature not yet available. Coming soon')}  type="dashed" icon="download" size="large">Export to Excel</Button></>
     }
     scroll={{ x: true }} bordered rowSelection={rowSelection}  rowKey={this.props.data.UID} columns={this.state.category && this.state.category=="Student" ? Studentcolumns : Facultycolumns} 
     dataSource={tableData}
      onChange={this.handleChange}  /> : null}
      </div>
    );
    }
}
 
export default GenTable;